import useAxiosRepository from '@/js/repositories/BaseRepository';
import { BellNotificationData } from '@/js/store/notifications/types/types';
import { notificationsApiEndpoints } from '@/js/store/notifications/constants/notificationsApiEndpoints';

const axiosRepo = useAxiosRepository();

export const fetchBellNotificationData = async (showError = true): Promise<BellNotificationData> => axiosRepo.get(notificationsApiEndpoints.NOTIFICATION_BELL, { showError });
